import { render, staticRenderFns } from "./ReturnList.vue?vue&type=template&id=0acf1831"
import script from "./ReturnList.vue?vue&type=script&lang=js"
export * from "./ReturnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports